///<reference path="strategy-base.ts"/>

module Meevo.Components.Controls.HideInput {

    export class StrategyDelete extends StrategyBase implements ITextChangeStrategy {
        getActualValue(selectionStart: number, selectionEnd: number): string {
            const areaSelected = selectionStart !== selectionEnd;

            return areaSelected
                ? this.actualValue.substring(0, selectionStart) + this.actualValue.substring(selectionEnd)
                : this.actualValue.substring(0, selectionStart) + this.actualValue.substring(selectionStart + 1, this.actualValue.length);
        }
    }
}
